import React, {useEffect, useState} from 'react';
import axios from 'axios';
import AddressGeoApi from "components/AddressGeoApi/AddressGeoApi";
import DatePicker, {registerLocale} from "react-datepicker";
import UseContext from "hooks/useContext";
import {enGB, fr} from "date-fns/locale";
import {dateToEpoch} from "../../../helper/helper";
import SectionWrapper, {FormField} from "../components/SectionWrapper";
import StyledDateInput from "components/styledInput/StyledDateInput";

registerLocale('en-GB', enGB)
registerLocale('fr-FR', fr)

const Location = () => {
    const {setData, data, setIsDateValid, companyData} = UseContext()
    const [address, setAddress] = useState('');
    const [error, setError] = useState(false)
    const [error1, setError1] = useState(false)

    useEffect(() => {
        if (Object.keys(address).length > 0) setData(prevData => ({
            ...prevData,
            location: address
        }))
    }, [address])

    useEffect(() => {
        if (Object.keys(data.location).length > 0) setAddress(data.location)
    }, [data.location])

    useEffect(() => {
        let dday = dateToEpoch(new Date())
        if (data.dateStart && data.dateEnd) {
            const d0 = dateToEpoch(data.dateStart)
            const d1 = dateToEpoch(data.dateEnd)
            if (d0 === d1) {
                setError(false)
            } else {
                setError(false)
                setError1(false)
            }
            if (d1 < d0) {
                setError(true)
            }
            if (d0 === dday) {
                setError1(false)
            }
            if (dday > d0) {
                setError1(true)
            } else if (dday === d0) {
                setError1(false)
            }
        }
    }, [data])

    useEffect(() => {
        if (!error && !error1) {
            setIsDateValid(true)
        } else {
            setIsDateValid(false)
        }
    }, [error, error1])

    const handleDateEnd = (date) => {

        if (dateToEpoch(data.dateEnd) !== dateToEpoch(date)) {
            setData(prevData => ({
                ...prevData,
                schedule: [],
                isConfirmedSchedule: false,
            }))
        }
        if (dateToEpoch(date) && dateToEpoch(data.dateStart)) {
            if (dateToEpoch(date) === dateToEpoch(data.dateStart)) {
                setData(prevData => ({
                    ...prevData,
                    isScheduleCheck: true,
                    isScheduleRequired: true,
                }))
            } else {
                setData(prevData => ({
                    ...prevData,
                    isScheduleCheck: true,
                    isScheduleRequired: false,
                }))
            }
        }

        setData(prevData => ({
            ...prevData,
            dateEnd: date
        }))
    }

    const handleDateStart = (date) => {

        if (dateToEpoch(data.dateStart) !== dateToEpoch(date)) {
            setData(prevData => ({
                ...prevData,
                schedule: [],
                isConfirmedSchedule: false,
            }))
        }
        if (dateToEpoch(data.dateEnd) && dateToEpoch(date)) {
            if (dateToEpoch(data.dateEnd) === dateToEpoch(date)) {
                setData(prevData => ({
                    ...prevData,
                    isScheduleCheck: true,
                    isScheduleRequired: true,
                }))
            } else {
                setData(prevData => ({
                    ...prevData,
                    isScheduleCheck: true,
                    isScheduleRequired: false,
                }))
            }
        }

        setData(prevData => ({
            ...prevData,
            dateStart: date
        }))
    }

    useEffect(() => {
        if (Object.keys(data.location).length === 0 && companyData.location) {
            const abortController = new AbortController();
            
            axios({
                method: 'get',
                url: `${process.env.REACT_APP_API_URL}address/${companyData.location}`,
                withCredentials: true,
                signal: abortController.signal
            })
                .then((res) => {
                    if(res.data){
                        setAddress(res.data)
                }
                })
                .catch((err) => {
                    // Ignorer les erreurs d'annulation (cleanup normal)
                    if (err.code !== 'ECONNABORTED' && err.code !== 'ERR_CANCELED' && err.name !== 'CanceledError') {
                        console.log(err)
                    }
                });
            
            return () => {
                abortController.abort();
            };
        }
    }, [data.location, companyData.location]);

    return (
        <SectionWrapper 
            title="Lieu et dates de la mission" 
            description="Indiquez l'adresse et les dates de début et de fin de la mission."
        >
                <AddressGeoApi addressGeoValue={setAddress}
                               addressValue={address}
                               isAddressCompany={true}
                               page={'createMission'}
                />
            <div className={'grid grid-cols-2 gap-4'}>
                <FormField label="Date de début">
                        <div className='relative'>
                            <DatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={data.dateStart}
                                onChange={(date) => handleDateStart(date)}
                                locale='fr-FR'
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown disabledKeyboardNavigation
                                dropdownMode="select"
                                popperPlacement="bottom"
                                customInput={<StyledDateInput/>}
                            />
                    </div>
                    {error1 ? <span className='ft-sm text-red-500'>Veuillez indiquer une date valide</span> : ''}
                </FormField>
                <FormField label="Date de fin">
                        <div className='relative'>
                            <DatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={data.dateEnd}
                                onChange={(date) => handleDateEnd(date)}
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown disabledKeyboardNavigation
                                locale='fr-FR'
                                dropdownMode="select"
                                popperPlacement="bottom"
                                customInput={<StyledDateInput/>}
                            />
                    </div>
                    {error ? <span className='ft-sm text-red-500'>Veuillez indiquer une date valide</span> : ''}
                </FormField>
            </div>
        </SectionWrapper>
    );
};

export default Location;
